import React, { Component } from 'react';
import * as pixi from 'pixi.js';
import _map from 'lodash/map';
import { Blobber } from 'src/components/blobber/Blobber';
import "./List.scss";

export class List extends Component {

  render() {
    const { color } = this.props;
    return (
      <div className="List">
        {/* <style dangerouslySetInnerHTML={{
          __html: [
            '.List ol li:before {',
            `  color: ${color}`,
            '}'
            ].join('\n')
          }}>
        </style> */}
        <ol ref="list">
          {this.props.children}
        </ol>
      </div>
    )
  }
}
